import ReactGA from "react-ga4";

const { REACT_APP_GTM_ADS_ID, REACT_APP_GTM_ADS_CONVERSION_ID } = process.env;

const CONVERSION_EVENT_NAME = "conversion";
const CONVERSION_RECEIVER = `${REACT_APP_GTM_ADS_ID}/${REACT_APP_GTM_ADS_CONVERSION_ID}`;

export const setUserEmail = (email) => {
  try {
    return ReactGA.gtag("set", "user_data", { email });
  } catch (error) {
    console.error("GTAG: Error setting user email ", error);
  }
};

export const setUserData = ({ phone, email, lastName, firstName }) => {
  try {
    return ReactGA.gtag("set", "user_data", {
      ...(email && { email }),
      ...(phone && { phone_number: phone }),
      ...((firstName || lastName) && {
        address: {
          ...(firstName && { first_name: firstName }),
          ...(lastName && { last_name: lastName }),
        },
      }),
    });
  } catch (error) {
    console.error("GTAG: Error setting user data ", error);
  }
};

export const setRestaurantName = (restaurant_name) => {
  try {
    return ReactGA.gtag("set", "user_data", {
      restaurant_name,
    });
  } catch (error) {
    console.error("GTAG: Error setting restaurant name ", error);
    return;
  }
};

export const setLocationToUser = (location) => {
  try {
    if (!location) return;
    const { street, region, country, state, city, restaurant_location } =
      location;
    return ReactGA.gtag("set", "user_data", {
      address: {
        region: region || "null",
        ...(street && { street }),
        ...(country && { country }),
        ...(state && { state }),
        ...(city && { city }),
        ...(restaurant_location && {
          restaurant_location: JSON.stringify(restaurant_location),
        }),
      },
    });
  } catch (error) {
    console.error("GTAG: Error setting location to user ", error);
  }
};

export const fireGoogleAdsConversion = () => {
  try {
    return ReactGA.event(CONVERSION_EVENT_NAME, {
      send_to: CONVERSION_RECEIVER,
    });
  } catch (error) {
    console.error("GTAG: Error firing Google Ads conversion ", error);
  }
};
